export function escapeHTML(string){
  return string.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, "&#x27;");
}


function simpleFormatWithMultiLineFeed(text) {
  return `<p>${safeJoin(text.split("\n"), "\n<br>")}</p>`;
}

function simpleFormatWithLink(text) {
  text = simpleFormatWithMultiLineFeed(text);
  const urlRegex = /(http|https):\/\/[^\s]+/g;
  return text.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank">${url}</a>`;
  });
}

function safeJoin(array, separator) {
  return array.join(separator);
}

export function escapeHTMLwithLink(text) {
  return simpleFormatWithLink(escapeHTML(text));
}

